
export default {
  name: 'TheFooter'
}
